import React from "react"
import ChevronRightIcon from "mdi-react/ChevronRightIcon";

import Footer from "./Footer";
import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, validateNestedData } from "../../../exportreport/utils"
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";
import CustomSkeleton from "./Skeleton";


const PropertyTypePage = (props) => {
	const { name, title, type, reportData, searchTags, summarizeGeographies, priorYearPeriodName, currentPeriodName, customDate, color , AiResponse, user} = props;
	const { dateOptions, theme, style } = customDate;

	const hasLocation = searchTags && searchTags.length>0
	return (
	  <div className="report-container page-section video-script">

		<section className="report-section">
		  <h3 className="header-text heading-location editable  video-title">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}</h3>
		  <div className="header-subtext__heading editable video-title">{type.name}</div>
		  <div className="subtext-grid">
			<div className="header-inner-subtext__heading editable video-title">
			  {type.title}
			</div>
			<div>
			  <div >Date Range</div>
			  <div className="editable">{priorYearPeriodName} vs. {currentPeriodName}</div>
			</div>
		  </div>
	  	  <hr/>
		  <div className="">
			
			  
			  {AiResponse && AiResponse && AiResponse.video_script ? AiResponse.video_script.map(sentence => {
				  return <div className="script-bubble"><div className="icon">
				  <ChevronRightIcon />
				  </div> <p className="editable copy-script">{sentence}</p></div>
			  }) :<CustomSkeleton count={30}/>}
			
		  
			
		  </div>
		</section>
		<Footer />
	  </div>
	)
  }
  
  export default PropertyTypePage;
